import {NextPageContext} from "next";
import Log from "@/utils/Log";
import Events from "@/utils/Events";
import ClientError from "@/pages/client_error";
import NotFound from "./not-found";

let event = new Events();

function ErrorPage({statusCode}: any) {
    event.trigger("error_page_show");
    if(statusCode === 404){
        return <NotFound/>
    }
    else {
        return <ClientError />
    }

}

ErrorPage.getInitialProps = ({res, err}: NextPageContext) => {
    event.trigger("error_page", {res, err})
    
    if(err){
        Log.sendApm({
            error: {
                message: err.message,
                name: err.name,
                stack: err.stack,
                cause: err.cause
            }
        });
    }

    console.error(res,err);

    let statusCode: number | undefined;
    if (res?.statusCode) {
        statusCode = res.statusCode
    } else if (err) {
        statusCode = err.statusCode
    } else {
        statusCode = 404;
    }
    return {statusCode};
};

export default ErrorPage;